var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 17,
    viewBox: "0 0 3 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_957_132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.11872 0.165042C0.333174 0.376176 -0.154298 1.19277 0.044417 1.96279C0.252446 2.75765 1.06593 3.25133 1.84527 3.04951C2.64013 2.84148 3.13381 2.02799 2.93199 1.25487C2.72396 0.450694 1.89805 -0.0460926 1.11872 0.165042Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.11872 6.67603C0.333174 6.88716 -0.154298 7.70375 0.044417 8.47377C0.252446 9.26863 1.06593 9.76231 1.84527 9.56049C2.64013 9.35247 3.13381 8.53898 2.93199 7.76585C2.72396 6.96168 1.89805 6.46489 1.11872 6.67603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.11872 13.1868C0.333174 13.3979 -0.154298 14.2145 0.044417 14.9845C0.252446 15.7794 1.06593 16.2731 1.84527 16.0712C2.64013 15.8632 3.13381 15.0497 2.93199 14.2766C2.72396 13.4724 1.89805 12.9756 1.11872 13.1868Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_957_132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseChat);
export default __webpack_public_path__ + "static/media/closeChat.3d7dd40e44cf587ce7af009d14235456.svg";
export { ForwardRef as ReactComponent };